module.exports = __webpack_public_path__ + "webauthn_38x38.c786a0db8b58be2a36d357612456304d.png";